// The navbar always renders on its own dark surface regardless of the app's
// light/dark mode, so its chakra-react-select dropdowns (Wholesaler,
// Currently Managing, Scope) should pin their focus ring and selected-option
// highlight to the brand colour's .500 step rather than falling back to
// chakraSelectDarkMode's dark-mode shades (brand.200 focus ring, and
// chakra-react-select's own black-on-grey selected-option default) — the
// same "always look right" treatment chakratheme.js's forceLightMode gives
// native Chakra Input/Select focus rings. Wraps (rather than replaces) the
// given base chakraSelectDarkMode styles so menuList/indicatorsContainer/etc
// still apply.
export const navbarSelectAccents = (colorScheme, base = {}) => ({
    ...base,
    control: (provided, state) => {
        const baseStyles = base.control
            ? base.control(provided, state)
            : provided;
        return {
            ...baseStyles,
            _focus: {
                ...baseStyles._focus,
                borderColor: `${colorScheme}.500`,
                boxShadow: `0 0 0 1px var(--chakra-colors-${colorScheme}-500)`,
            },
        };
    },
    option: (provided, state) => {
        const baseStyles = base.option
            ? base.option(provided, state)
            : provided;
        const { isFocused, isSelected } = state;
        return {
            ...baseStyles,
            backgroundColor: isSelected
                ? `${colorScheme}.500`
                : isFocused
                  ? 'whiteAlpha.100'
                  : (baseStyles.backgroundColor ?? null),
            color: isSelected ? 'white' : baseStyles.color,
            borderRadius: '0.25rem',
        };
    },
});

export const customAutoCompleteStyle = (colorScheme) => ({
    '[class*="MuiInputBase-root"]': {
        borderRadius: '0.375rem',
    },
    '[class*="MuiFormControl-root"]': {
        paddingInline: 0,
    },
    '[role="progressbar"]': {
        width: '1rem!important',
        height: '1rem!important',
        mr: '0.75rem',
    },
    '& [class*="MuiAutocomplete-popupIndicator"]': {
        transform: 'none',
        '& span > svg': {
            transitionDuration: '.4s',
        },
        '&[aria-label="Close"] span > svg': {
            transform: 'rotate(-180deg)',
        },
        '&[aria-label="Open"] span > svg': {
            transform: 'rotate(0deg)',
        },
    },
    '.MuiSelect-root': {
        '&.MuiSelect-select:focus': {
            backgroundColor: 'inherit',
        },
    },
    '[class*="MuiFormLabel-root"].Mui-focused, ': {
        color: `${colorScheme}.500`,
        '[class*="MuiOutlinedInput"].Mui-focused [class*="MuiOutlinedInput-notchedOutline"] ':
            {
                borderColor: `${colorScheme}.500`,
            },
    },
});

// Kept short so the tooltip doesn't overflow the viewport edge and add a
// scroll bar (3191).
export const supportTooltipLabel = (trialStatus) =>
    trialStatus?.status ? `Status: ${trialStatus.status}` : 'Support';
